import { render, staticRenderFns } from "./clientList.vue?vue&type=template&id=0c71f520&scoped=true&"
import script from "./clientList.vue?vue&type=script&lang=js&"
export * from "./clientList.vue?vue&type=script&lang=js&"
import style0 from "./clientList.vue?vue&type=style&index=0&id=0c71f520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c71f520",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c71f520')) {
      api.createRecord('0c71f520', component.options)
    } else {
      api.reload('0c71f520', component.options)
    }
    module.hot.accept("./clientList.vue?vue&type=template&id=0c71f520&scoped=true&", function () {
      api.rerender('0c71f520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/activityManage/activityAccount/poolPop/clientList.vue"
export default component.exports